import type { ThunkDependencies } from "single-spa/store/thunk-dependencies";
import type { ThunkDispatchCommon, ThunkGetState } from "single-spa/store/types";

import * as actionCreators from "./action-creators";

export const fetchContactsStatusThunk = () => {
    return async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        dispatch(actionCreators.fetchContactsStatusAsync.request());

        try {
            const status = await deps.si.api.contacts.fetchContactsStatus();
            dispatch(actionCreators.fetchContactsStatusAsync.success(status));
        } catch (e) {
            dispatch(actionCreators.fetchContactsStatusAsync.failure(e));
        }
    };
};

export const approveContactsTermsThunk =
    () => async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        dispatch(actionCreators.approveContactsTermsAsync.request());

        try {
            await deps.si.api.contacts.acceptContactsTerms();

            return dispatch(actionCreators.approveContactsTermsAsync.success());
        } catch (e) {
            return dispatch(actionCreators.approveContactsTermsAsync.failure(e));
        }
    };

export const fetchContactsAdminsThunk = () => {
    return async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        dispatch(actionCreators.fetchContactsAdmins.request());

        try {
            const admins = await deps.si.api.contactAdmin.fetchAccountAdmins();
            dispatch(actionCreators.fetchContactsAdmins.success(admins));
        } catch (e) {
            dispatch(actionCreators.fetchContactsAdmins.failure(e));
        }
    };
};
